<h2 class="sublist-title">{{ sublistTitle }}</h2>
<ul class="list-unstyled">
  <ng-container *ngFor="let sublistItem of sublistItems" class="sublist-item">
    <li
      class="sublist-item"
      [ngClass]="{
        'selected-item': selectedItem && selectedItem.id == sublistItem.id
      }"
      (click)="selectItem.emit(sublistItem)"
      *ngIf="sublistItem[criteria] == criteriaValue"
    >
      <p
        class="sublist-item-text"
        [ngClass]="{
          'sublist-item-text-delete-conf':
            clickedDeleteSublistItemId == sublistItem.id &&
            itemIsShared(sublistItem)
        }"
      >
        <ng-container *ngIf="sublistItem.name != null">{{
          sublistItem.name
        }}</ng-container>
        <ng-container *ngIf="sublistItem.name == null">[new view]</ng-container>
      </p>
      <ng-container *ngIf="sublistItem[criteria] == showDeleteCriteriaValue">
        <img
          [src]="'../../assets/images/views_trash.svg'"
          class="delete-img"
          (click)="clickedDeleteSublistItemId = sublistItem.id"
          alt="Delete"
          *ngIf="
            !clickedDeleteSublistItemId ||
            clickedDeleteSublistItemId != sublistItem.id
          "
        />
        <div
          *ngIf="clickedDeleteSublistItemId == sublistItem.id"
          class="delete-confirm"
        >
          <p *ngIf="itemIsShared(sublistItem)" class="delete-confirm-warning">
            Warning! This {{ type }} is shared with other users. Confirm delete?
          </p>
          <delete-view-confirmation
            (deleteConfirmed)="deleteSublistItem($event, sublistItem)"
          >
          </delete-view-confirmation>
        </div>
      </ng-container>
    </li>
  </ng-container>
</ul>
